/**
 * The New Academic Word List (NAWL) 1.2, adapted for matching.
 *
 * Source: Browne, C., Culligan, B., & Phillips, J. (2013). New Academic Word List
 * (version 1.2), the file "alphabetized and lemmatized for teaching", downloaded from
 * https://www.newgeneralservicelist.com/new-academic-word-list
 *
 * Licence: "New Academic Word List by Browne, C., Culligan, B., and Phillips, J. is
 * licensed under a Creative Commons Attribution-ShareAlike 4.0 International License"
 * (https://creativecommons.org/licenses/by-sa/4.0/). This file is an adaptation of the
 * list and is shared under the same licence, CC BY-SA 4.0. The tool page that uses it
 * (/tools/academic-vocabulary-checker) carries the attribution and this notice.
 *
 * Changes from the original:
 * - accented spellings are folded into their plain forms (élite → elite) and the
 *   duplicates that folding creates are removed;
 * - eight words are left out — incredible, incredibly, nasty, ridiculous, super, tech,
 *   terribly, tricky — because they come from the list's spoken data and CitationEasy's
 *   own formal-writing checkers flag them as informal;
 * - the entry the original heads "founds" is shown under the lemma "found", and bare
 *   "found" is never matched (see `DISPLAY_ONLY` in academic-vocabulary.ts): it is nearly
 *   always the past tense of "find", a general-English word the NAWL does not include.
 *
 * One line per lemma: the lemma first, then its inflected forms, comma-separated.
 */
export const NAWL_LEMMAS = `
abdominal,abdominals
absorb,absorbs,absorbed,absorbing
absorption,absorptions
accelerate,accelerates,accelerated,accelerating
acceleration,accelerations
accent,accents,accented,accenting
accumulate,accumulates,accumulated,accumulating
accumulation,accumulations
accuracy,accuracies
accurately
acid,acids
acidic,acidics
activate,activates,activated,activating
actively
acute,acutest
adaptation,adaptations
adaptive,adaptives
adjacent,adjacents
admission,admissions
adolescent,adolescents
adverse
aerosol,aerosols
aesthetic,aesthetics,esthetic,esthetics
affirm,affirms,affirmed,affirming
afterward,afterwards
aggregate,aggregates,aggregated,aggregating
agriculture,agricultures
airplane,airplanes,aeroplane,aeroplanes
algebra,algebras
algorithm,algorithms
alien,aliens
alliance,alliances
allocate,allocates,allocated,allocating
allocation,allocations
altitude,altitudes
aluminum,aluminium
amino
amongst
amplitude,amplitudes
analogy,analogies
ancestor,ancestors
anthropology,anthropologies
anti,antis
antibiotic,antibiotics
antibody,antibodies
antiquity,antiquities
appendix,appendices,appendixes
applause
apple,apples
approximate,approximates,approximated,approximating
approximation,approximations
arbitrary
archaeology,archaeologies
architect,architects,architected,architecting
array,arrays,arrayed,arraying
arrow,arrows,arrowed,arrowing
articulate,articulates,articulated,articulating
artifact,artifacts,artefact,artefacts
artificial,artificials
artistic,artistics
artwork,artworks
aspect,aspects
assembly,assemblies
assert,asserts,asserted,asserting
assignment,assignments
athletic,athletics
atom,atoms
atomic,atomics
auction,auctions,auctioned,auctioning
audio
audit,audits,audited,auditing
authority,authorities
autonomy,autonomies
availability,availabilities
axiom,axioms
axis
backward,backwards
bacteria
bacterial,bacterials
bang,bangs,banged,banging
bargain,bargains,bargained,bargaining
barrel,barrels,barrelled,barrelling,barreled,barreling
basin,basins,basined
bat,bats,batted,batting,battings
beam,beams,beamed,beaming
behavioral,behavioural
bilingual,bilinguals
binary,binarys,binaries
biodiversity
biologist,biologists
biology,biologies
bizarre
blank,blanks,blanked,blanking,blanker
bleed,bleeds,bled,bleeding,bleedin
bodily
bonus,bonuses
bound,bounds,bounded,bounding
bracket,brackets,bracketed,bracketted
breakdown,breakdowns
broadly
bubble,bubbles,bubbled,bubbling
bucket,buckets
bulk,bulks,bulked,bulking
bullet,bullets
bundle,bundles,bundled,bundling
calcium
calculation,calculations
calculator,calculators
calculus
campus,campuses
capillary,capillaries
capitalism,capitalisms
capitalist,capitalists
carrier,carriers
cattle
censor,censors,censored,censoring,censorings
characterization,characterizations,characterisation,characterisations
cheat,cheats,cheated,cheating,cheatings
cheer,cheers,cheered,cheering
chemistry,chemistries
chemotherapy,chemotherapies
chess
chloride,chlorides
chromosome,chromosomes
chronic,chronics
chunk,chunks,chunked,chunking
cinema,cinemas
circa
circulate,circulates,circulated,circulating
circulation,circulations
civilization,civilizations,civilisation,civilisations
clarify,clarifies,clarified,clarifying
classification,classifications
classify,classifies,classified,classifying
classroom,classrooms
clay,clays
clever,cleverer,cleverest
client,clients
clinic,clinics
clip,clips,clipped,clipping,clippings
clone,clones,cloned,cloning
closure,closures
clue,clues,clued,cluing
coefficient,coefficients
cognitive
coherent
collective,collectives
colonial,colonials
colony,colonies
comma,commas
commentary,commentaries
commodity,commodities
commonly
communicative
communist,communists
compact,compacts,compacted,compacting,compacter
comparable,comparables
comparative,comparatives
compensate,compensates,compensated,compensating
competence,competences
competent
complement,complements,complemented,complementing
complication,complications
comply,complies,complied,complying
composer,composers
composite
comprehension
computation,computations
conceive,conceives,conceived,conceiving
conception,conceptions
conceptual,conceptuals
conditional,conditionals
conduction
cone,cones
configuration,configurations
confine,confines,confined,confining
confound,confounds,confounded,confounding
congruent
connector,connectors
connotation,connotations
conscious
consciousness,consciousnesses
consensus
consent,consents,consented,consenting
conservation,conservations
conserve,conserves,conserved,conserving
consonant,consonants
constitution,constitutions
constrain,constrains,constrained,constraining
consultation,consultations
consumption,consumptions
container,containers
continent,continents
continuity,continuities
contour,contours,contoured,contouring
contradict,contradicts,contradicted,contradicting
contradiction,contradictions
contradictory
contrary,contraries
controversy,controversies
converge,converges,converged,converging
convergence,convergences
coordinate,coordinates,coordinated,coordinating
coordination,coordinations
cord,cords,corded,cording
coronary
corpus
correction,corrections
correctly
correlate,correlates,correlated,correlating
correlation,correlations
correspondence,correspondences
corruption,corruptions
cortex,cortexes,cortices
credibility
criteria
critically
critique,critiques,critiqued,critiquing
crude,cruder,crudest
crystal,crystals
cue,cues,cued,cueing
cure,cures,cured,curing
curriculum,curriculums,curricula
cyclic,cyclics
cylinder,cylinders
damp,damps,damped,damping,dampest
deadline,deadlines
decay,decays,decayed,decaying
deceive,deceives,deceived,deceiving
defect,defects,defected,defecting
deficiency,deficiencies
definite
deflection,deflections
degrade,degrades,degraded,degrading
deliberately
delta,deltas
demonstrator,demonstrators
denominator,denominators
denote,denotes,denoted,denoting
dense,denser,densest
dependence,dependences
depict,depicts,depicted,depicting
derivative,derivatives
descendent,descendents
descriptor,descriptors
destination,destinations
detection,detections
developmental,developmentals
deviation,deviations
diagnose,diagnoses,diagnosed,diagnosing
diagnosis
diagnostic,diagnostics
diagram,diagrams,diagrammed,diagramming
dialect,dialects
diameter,diameters
diary,diaries
dictate,dictates,dictated,dictating
dictionary,dictionaries
differential,differentials
differentiate,differentiates,differentiated,differentiating
differentiation,differentiations
diffusion,diffusions
dilemma,dilemmas
dilute,dilutes,diluted,diluting
dimensional,dimensionals
dioxide,dioxides
directive,directives
disability,disabilities
disadvantage,disadvantages,disadvantaged,disadvantaging
discharge,discharges,discharged,discharging
discourse,discourses,discoursed,discoursing
discrete
discrimination,discriminations
displacement,displacements
dissection,dissections
dissertation,dissertations
dissolve,dissolves,dissolved,dissolving
distribution,distributions
disturbance,disturbances
diverse
domain,domains
dominance,dominances
dominant
domination,dominations
donor,donors
dose,doses,dosed,dosing
drain,drains,drained,draining
drift,drifts,drifted,drifting,driftin
duration,durations
dye,dyes,dyed,dyeing
dynamic,dynamics
ecological,ecologicals
ecology,ecologies
economically
economist,economists
effectiveness
elaborate,elaborates,elaborated,elaborating
elastic,elastics
elasticity,elasticities
electron,electrons
elementary
elevate,elevates,elevated,elevating
elevation,elevations
elimination,eliminations
elite,elites
embed,embeds,embedded,embedding,embeddings
emergence,emergences
emission,emissions
emit,emits,emitted,emitting
emperor,emperors
empirical,empiricals
encode,encodes,encoded,encoding,encodings
enforcement,enforcements
enormously
entity,entities
entrant,entrants
enzyme,enzymes
epidemic,epidemics
epidemiology,epidemiologies
equality,equalities
equilibrium
equivalence,equivalences
erase,erases,erased,erasing
essence,essences
essentially
estimation,estimations
ethical,ethicals
ethics,ethic
evident,evidents
evolutionary
ex,exes
execute,executes,executed,executing
execution,executions
exit,exits,exited,exiting
expertise,expertises
explicit
explicitly
exploit,exploits,exploited,exploiting
exponential,exponentials
fabric,fabrics
facet,facets,faceted,faceting
facilitate,facilitates,facilitated,facilitating
factorial,factorials
faculty,faculties
fatigue,fatigues,fatigued,fatiguing
feedback,feedbacks
fertility
fetal,foetal
fever,fevers,fevered
fiber,fibers,fibres,fibre
fin,fins,finned,finning
finite
flesh,fleshes,fleshed,fleshing
flexibility,flexibilities
flip,flips,flipped,flipping
fluid,fluids
flux,fluxes,fluxed,fluxing
footnote,footnotes,footnoted,footnoting
formally
formulation,formulations
forum,forums,fora
fossil,fossils
found,founds,founded,founding,foundings
fraction,fractions
fracture,fractures,fractured,fracturing
freely
friction,frictions
fringe,fringes,fringed,fringing
fundamentally
fungus,fungi
fusion,fusions
gauge,gauges,gauged,gauging,gage,gages,gaged,gaging
generalization,generalizations,generalisation,generalisations
generalize,generalizes,generalized,generalizing,generalise,generalises,generalised,generalising
genetically
genetics
ghost,ghosts,ghosted,ghosting
globalization,globalizations,globalisation,globalisations
goat,goats
goodness
goods
gradient,gradients
gram,grams
grammatical,grammaticals
graph,graphs,graphed,graphing
grasp,grasps,grasped,grasping
gravity,gravities
grid,grids
gross,grosses,grossed,grossing,grosser,grossest
gut,guts,gutted,gutting
habitat,habitats
halfway,halfways
handout,handouts
harvest,harvests,harvested,harvesting,harvestings
hawk,hawks,hawked,hawking
headquarter,headquarters,headquartered,headquartering
hedge,hedges,hedged,hedging
helix,helixes,helices
hepatitis
herbicide,herbicides
hierarchy,hierarchies
hip,hips,hipped
historically
homework,homeworks
horizon,horizons
horizontal,horizontals
hormone,hormones
hydrogen,hydrogens
identical,identicals
identification,identifications
ideology,ideologies
illusion,illusions
immune
impact,impacts,impacted,impacting
implicit
importantly
impulse,impulses
incidence,incidences
incline,inclines,inclined,inclining
inclusion,inclusions
incumbent,incumbents
independently
indicator,indicators
indifference,indifferences
indigenous
indirect,indirects
individually
induce,induces,induced,inducing
induction,inductions
industrialization,industrializations,industrialisation
industrialize,industrializes,industrialized,industrializing,industrialise,industrialises,industrialised,industrialising
inequality,inequalities
inevitably
infect,infects,infected,infecting
infectious
inference,inferences
inferior,inferiors
infinite
infinity,infinities,infinitys
influential,influentials
informal,informals
inhibit,inhibits,inhibited,inhibiting
inhibition,inhibitions
initiate,initiates,initiated,initiating
initiation,initiations
inject,injects,injected,injecting
injection,injections
innate
insect,insects
insert,inserts,inserted,inserting
instability,instabilities
instinct,instincts
integral,integrals
integration,integrations
intensity,intensities
intensive
interact,interacts,interacted,interacting
interestingly
interface,interfaces,interfaced,interfacing,interfacings
interfere,interferes,interfered,interfering
intermediate,intermediates,intermediated,intermediating
interrupt,interrupts,interrupted,interrupting
interval,intervals
intervene,intervenes,intervened,intervening
interviewer,interviewers
invade,invades,invaded,invading
invasion,invasions
inversion,inversions
invert,inverts,inverted,inverting
ion,ions
irrelevant
irrigation,irrigations
jazz,jazzes,jazzed,jazzing
junior,juniors
justification,justifications
kidney,kidneys
kilometer,kilometers,kilometres,kilometre
lab,labs
lateral,laterals
layout,layouts
leaf,leafs,leafed,leafing
lecturer,lecturers
legend,legends
legitimate,legitimates,legitimated,legitimating
leisure,leisures
lever,levers,levered,levering
lexical,lexicals
liable,liables
lifestyle,lifestyles
lifetime,lifetimes
likelihood,likelihoods
likewise
limb,limbs,limbed
linear,linears
linguistic
linguistics
liter,liters,litres,litre
liver,livers
locally
locus,locuses,loci
logical,logicals
longitudinal,longitudinals
loop,loops,looped,looping
lump,lumps,lumped,lumping
lung,lungs
machinery,machineries
magnetic,magnetics
magnitude,magnitudes
mall,malls
manipulate,manipulates,manipulated,manipulating
manipulation,manipulations
manual,manuals
manuscript,manuscripts
marble,marbles,marbled
marginal,marginals
marker,markers
marrow,marrows
maternal,maternals
mathematical,mathematicals
matrix,matrices,matrixes
maximize,maximizes,maximized,maximizing,maximise,maximises,maximised,maximising
meaningful
mechanic,mechanics
mechanical,mechanicals
media
mediate,mediates,mediated,mediating
membrane,membranes
memorize,memorizes,memorized,memorizing,memorise,memorises,memorised,memorising
mentor,mentors,mentored,mentoring
mercury
merge,merges,merged,merging
messenger,messengers
metabolism,metabolisms
metaphor,metaphors
methodology,methodologies
micro
mid
migrate,migrates,migrated,migrating
migration,migrations
millimeter,millimeters,millimetres,millimetre
mineral,minerals
minimal,minimals
minimize,minimizes,minimized,minimizing,minimise,minimises,minimised,minimising
minus,minuses
missile,missiles
mobility,mobilities
modification,modifications
mole,moles
molecular,moleculars
molecule,molecules
momentum,momentums,momenta
monetary
monkey,monkeys,monkeyed,monkeying
monopoly,monopolies
morality,moralities
morphological,morphologicals
morphology,morphologies
mortality,mortalities
motif,motifs
motive,motives
multi
multinational,multinationals
multiply,multiplies,multiplied,multiplying
mutation,mutations
myth,myths
naked
namely
nationalism,nationalisms
neat,neater,neatest
necessity,necessities
neo
nest,nests,nested,nesting
neural,neurals
neuron,neurons,neurone,neurones
neutral,neutrals
nicely
niche,niches
nitrogen,nitrogens
noble,nobles,nobler,noblest
node,nodes
noisy,noisier,noisiest
nominal,nominals
non
nonetheless
nonlinear,nonlinears
norm,norms
notation,notations
novice,novices
nucleus,nuclei
null,nulls,nulled,nulling
numerical,numericals
nutrient,nutrients
objection,objections
obscure,obscures,obscured,obscuring
observer,observers
obtain,obtains,obtained,obtaining
occupation,occupations
occurrence,occurrences
offspring,offsprings
onset,onsets
onwards
optical,opticals
optimal,optimals
optimum
oral,orals
organ,organs
organism,organisms
orient,orients,oriented,orienting
orientation,orientations
oscillation,oscillations
outer,outers
outlet,outlets
overhead,overheads
overlap,overlaps,overlapped,overlapping
overview,overviews,overviewed,overviewing
oxidize,oxidizes,oxidized,oxidizing,oxidise,oxidises,oxidised,oxidising
oxygen,oxygens
painful
par,pars,parred,parring
paradigm,paradigms
paradox,paradoxes
parameter,parameters
parcel,parcels,parceled,parceling,parcelled,parcelling
pardon,pardons,pardoned,pardoning
parental,parentals
parenthesis,parentheses
partial,partials
partially
particle,particles
partition,partitions,partitioned,partitioning
pathway,pathways
peasant,peasants
periodic,periodics
peripheral,peripherals
pest,pests
pesticide,pesticides
phenomenal,phenomenals
philosopher,philosophers
philosophical,philosophicals
phonological,phonologicals
phosphate,phosphates
photographic,photographics
physically
physician,physicians
physics
physiological,physiologicals
pi
planner,planners
plantation,plantations
plausible,plausibles
plug,plugs,plugged,plugging
plural,plurals
polar,polars
pole,poles,poled,poling
politically
portfolio,portfolios
portray,portrays,portrayed,portraying
portrayal,portrayals
positively
poster,posters
postgraduate,postgraduates
potassium
powder,powders,powdered,powdering
practitioner,practitioners
pragmatic,pragmatics
pre
precede,precedes,preceded,preceding
precipitate,precipitates,precipitated,precipitating
precipitation,precipitations
predator,predators
prediction,predictions
predominantly
prejudice,prejudices,prejudiced,prejudicing
preliminary,preliminaries
presume,presumes,presumed,presuming
prevalence,prevalences
prey,preys,preyed,preying
primer,primers
primitive,primitives
probe,probes,probed,probing
problematic,problematics
processor,processors
productive
productivity,productivities
profound,profounder,profoundest
progression,progressions
progressive
projection,projections
prominent
pronounce,pronounces,pronounced,pronouncing
proposition,propositions,propositioned,propositioning
protocol,protocols
proton,protons
psychiatric,psychiatrics
psychologist,psychologists
psychology,psychologies
publish,publishes,published,publishing
pulse,pulses,pulsed,pulsing
punch,punches,punched,punching
punish,punishes,punished,punishing
punishment,punishments
purely
puzzle,puzzles,puzzled,puzzling
qualitative
quantitative
quantum
questionnaire,questionnaires
quiz,quizs,quizzes,quizzed,quizzing,quizzings
quotation,quotations
rack,racks,racked,racking
radar,radars
radiation,radiations
radius,radii
rainfall,rainfalls
randomize,randomizes,randomized,randomizing,randomise,randomises,randomised,randomising
randomly
rational,rationals
rationality,rationalities
ray,rays,rayed,raying
reactive
reactor,reactors
readily
realism,realisms
realistic,realistics
realm,realms
receptor,receptors
recipe,recipes
reconstruct,reconstructs,reconstructed,reconstructing
regime,regimes
regression,regressions
rehabilitation,rehabilitations
reinforce,reinforces,reinforced,reinforcing
rejection,rejections
reliability,reliabilities
render,renders,rendered,rendering,renderings
repertoire,repertoires
replacement,replacements
replicate,replicates,replicated,replicating
replication,replications
reproduce,reproduces,reproduced,reproducing
reproduction,reproductions
republic,republics
resemble,resembles,resembled,resembling
reservoir,reservoirs
residual,residuals
residue,residues
resistant
respiratory
retrieve,retrieves,retrieved,retrieving
revolutionary,revolutionaries
rewrite,rewrites,rewrote,rewritten,rewrited,rewriting,rewrit
rhetoric,rhetorics
rhythm,rhythms
ritual,rituals
robot,robots
rope,ropes,roped,roping
rotate,rotates,rotated,rotating
rotation,rotations
rub,rubs,rubbed,rubbing,rubbings
ruler,rulers
scatter,scatters,scattered,scattering,scatterings
scenario,scenarios
scholarship,scholarships
scripture,scriptures
scroll,scrolls,scrolled,scrolling
secrete,secretes,secreted,secreting
sediment,sediments,sedimented,sedimenting
selective
semantic,semantics
semester,semesters
semi
seminar,seminars
sensation,sensations
sensible,sensibles
sensitivity,sensitivities
sensory
separately
separation,separations
sexuality,sexualities
shallow,shallows,shallowed,shallowing,shallower,shallowest
shortly
shuttle,shuttles,shuttled,shuttling
similarity,similarities
simplify,simplifies,simplified,simplifying
simulate,simulates,simulated,simulating
simulation,simulations
simultaneously
sin,sins,sinned,sinning
singular,singulars
sketch,sketches,sketched,sketching
skip,skips,skipped,skipping
slab,slabs,slabed,slabing
slash,slashes,slashed,slashing,slashings
slavery
slot,slots,slotted,slotting
snake,snakes,snaked,snaking
sneeze,sneezes,sneezed,sneezing
sniff,sniffs,sniffed,sniffing
socialize,socializes,socialized,socializing,socialise,socialises,socialised,socialising
socially
sodium,sodiums
soluble,solubles
solute,solutes
solvent,solvents
sometime
sophisticate,sophisticated,sophisticating,sophisticates
span,spans,spanned,spanning
spatial,spatials
specialty,specialties,speciality,specialities
specification,specifications
specimen,specimens
spectrum,spectrums,spectra
sperm,sperms
sphere,spheres
splice,splices,spliced,splicing
sponsorship,sponsorships
spontaneous
spray,sprays,sprayed,spraying,sprayings
stabilize,stabilizes,stabilized,stabilizing,stabilise,stabilises,stabilised,stabilising
stack,stacks,stacked,stacking
stadium,stadiums
stance,stances,stanced,stancing
standardize,standardizes,standardized,standardizing,standardise,standardises,standardised,standardising
static,statics
statistical,statisticals
statistically
statistics
stereotype,stereotypes,stereotyped,stereotyping
stimulus,stimuli
straightforward
strand,strands,stranded,stranding
strategic
strictly
stripe,stripes,striped,striping
sub,subs,subbed,subbing
subjective
subset,subsets
substitution,substitutions
substrate,substrates
subtle,subtler,subtlest
subtract,subtracts,subtracted,subtracting
sufficiently
suicide,suicides
superior,superiors
supposedly
surgeon,surgeons
surgical,surgicals
surplus,surpluses
susceptible,susceptibles
sustainable,sustainables
swap,swaps,swapped,swapping
swell,swells,swelled,swelling,swollen
sword,swords,sworded,swording
syllable,syllables,syllabled
syllabus,syllabi,syllabuses
symbolic,symbolics
syndrome,syndromes
syntactic,syntactics
syntax
synthesis,syntheses
synthetic,synthetics
systematic,systematics
technically
temporal,temporals
tempt,tempts,tempted,tempting
tense,tenses,tensed,tensing
terminal,terminals
terminology,terminologies
textbook,textbooks
theorem,theorems
theorist,theorists
thereby
thermal,thermals
thesis,theses
thickness,thicknesses
thread,threads,threaded,threading
threshold,thresholds
thumb,thumbs,thumbed,thumbing
tolerance,tolerances
ton,tons
toxic,toxics
tract,tracts
traditionally
trait,traits
trajectory,trajectories
trans
transaction,transactions
transcribe,transcribes,transcribed,transcribing
transcription,transcriptions
transformation,transformations
translation,translations
transmission,transmissions
transmit,transmits,transmitted,transmitting
transparency,transparencies
transplant,transplants,transplanted,transplanting
trauma,traumas
treaty,treaties
tremendous
triangle,triangles
tribe,tribes
trivial,trivials
tropical,tropicals
tumor,tumors,tumour,tumours
turbulent
tutor,tutors,tutored,tutoring
ultimate,ultimates
undergraduate,undergraduates
undermine,undermines,undermined,undermining
underneath
unemployed
unify,unifies,unified,unifying
unintelligible,unintelligibles
unity,unities
unstable,unstables
uplift,uplifts,uplifted,uplifting
upward,upwards
urine
usage,usages
utility,utilities
utilize,utilizes,utilized,utilizing,utilise,utilises,utilised,utilising
utterance,utterances
vague
valid
validity,validities
valve,valves,valved
variability,variabilities
variance,variances
variant,variants
vector,vectors
vegetation
vein,veins,veined,veining
velocity,velocities
verbal,verbals
vertical,verticals
viable,viables
virtue,virtues
vitamin,vitamins
vocabulary,vocabularies
volition,volitions
vowel,vowels
watershed,watersheds
wavelength,wavelengths
weave,weaves,wove,weaving,woven,weaved,weavings
wheat,wheats
whereby
whichever,whichevers
whoever,whoevers
widespread,widespreads
wisdom,wisdoms
workshop,workshops
yeast,yeasts
`;
